import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { DataService } from '../../services/data.service';
import { PackageType } from 'src/app/models/packagetype';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TransportMode } from 'src/app/models/transportmode';
import { SourceType } from 'src/app/models/sourcetype';
import { FormService } from 'src/app/services/form';
import { MatSnackBar } from '@angular/material';
import { ProposalService } from 'src/app/services/proposal.service';
import { ValidateEffectivityFrom } from 'src/app/commonUI/customValidators/proposaliinfofields.valdiator';
import { MultiSelectItem } from '@tesla/angular2-tesla-common/tesla-common';
import { PackageMaterial } from '../../models/packagematerial';
import { ToastService } from '../../services/toaster/toaster.service';
import { Constants } from '../../core/constants';
import { LocalstorageService } from '../../services/localstorage.service';
import { UnitOfMeasurement } from '../../models/internal/unit-of-measurement';
import Helper from '../../core/utility/helper';
import { WhereInFilter } from '../../models/internal/wherein-filter';
import { Router, ActivatedRoute } from '@angular/router';
import { PackageLevelTemplate } from '../../models/packageleveltemplate';
import cloneDeep from 'lodash/cloneDeep';
import { QueryPackageTemplatesForSupplierDTO } from '../../models/internal/query-packagetemplates-forsupplier-dto';
import { QueryPackageTemplatesForPEDTO } from '../../models/internal/query-packagetemplates-for-pe-dto';
import { BasePage } from '../../core/basepages/allbasepages';
import { QueryGetMaterialDTO } from '../../models/internal/query-getmaterial-dto';
import { CanDeactivate } from '@angular/router/src/utils/preactivation';
import { ComponentCanDeactivate } from '../../core/interfaces/component-can-deactive.interface';
import { NGXLogger } from 'ngx-logger';
import { AppSettings } from 'src/app/app.settings';
import { PackageTemplateFile } from 'src/app/models/package-template-file';
import { PackageTemplateSupCode } from 'src/app/models/package-template-supcode';
import { TeslaAutocompleteComponent } from '@tesla/angular2-tesla-common/autocomplete/autocomplete.component';
import { AddPackageLevelTemplateSupplierDTO } from 'src/app/models/addpltsupplier-dto';
import { TslFileDrop } from '@tesla/ng-tds';

@Component({
  selector: 'app-packagelevel-template-view',
  templateUrl: './packagelevel-template-view.component.html',
  styleUrls: ['./packagelevel-template-view.component.scss']
})
export class PackagelevelTemplateViewComponent extends BasePage implements OnInit, ComponentCanDeactivate {
    packageLevelTemplateDTO: PackageLevelTemplate;
    globalUOM: UnitOfMeasurement = new UnitOfMeasurement();
    showSecondaryLevelTemplateCodes: boolean;
    preferredSecondaryTemplateList: any[];
    partNumbers: string[];
    PackageLevelTemplateForm: FormGroup;
    supplierInfoForm: FormGroup;
    addPackageLevelTemplateSupplierDTO: AddPackageLevelTemplateSupplierDTO = new AddPackageLevelTemplateSupplierDTO();
    @ViewChild('SupplierAutoComplete') SupplierAutoComplete: TeslaAutocompleteComponent;
    @Output() private formReady: EventEmitter<FormGroup> = new EventEmitter<
        FormGroup
    >();
    @ViewChild('fileDrop') fileDrop: TslFileDrop;
    loadedFiles: File[] = [];
    public packageLevelList = [
        { Id: 1, Description: 'Primary' },
        { Id: 2, Description: 'Secondary' },
    ];
    addClicked = false;
    supplierAssginmentMessage: string = '';
    supplierCodesList: string[] = [];
    searchSupplierURL: string;
    public packageTypeList: PackageType[];
    public transportModeList: TransportMode[];
    public packageMaterialList: PackageMaterial[];
    public packageLevelTemplateFiles: PackageTemplateFile[];
    public packageLevelTemplateSupCodes: PackageTemplateSupCode[];
    isPltSupCodeExists = false;
    isPltUploadExists = false;
    SubmitClicked = false;
    selectedSourceTypes: MultiSelectItem[] = [];
    @Output() tabChangeRequested = new EventEmitter<number>();
    @Output() formUpdated = new EventEmitter<number>();
    myFilter = (d: Date): boolean => {
        const day = d.getDay();
        // Prevent Saturday and Sunday from being selected.
        return day !== 0 && day !== 6;
    };
    locStorage = Constants.localStorageKeys;
    packageLevelTemplateId: string;
    isUpdateMode = false;
    constructor(
        private dataService: DataService,
        private fb: FormBuilder,
        private proposalService: ProposalService,
        public FormService: FormService,
        localstorageService: LocalstorageService,
        logger: NGXLogger,
        appSettings: AppSettings,
        private toastService: ToastService,
        private readonly route: ActivatedRoute,
        private router: Router
        ) {
            super(localstorageService, logger, appSettings);
        this.PackageLevelTemplateForm = this.fb.group({
            Id: 0,
            UOMSystemId: [Constants.IMPERIAL_UOM_ID],
            PackageLevelId: [null],
            PackageTypeId: [null],
            TransportModeId: [null],
            PackageMaterialId: [null],
            ODLength: [null],
            ODWidth: [null],
            ODHeight: [null],
            IDLength: [null],
            IDWidth: [null],
            IDHeight: [null],
            TareWeight: [null],
            MaxWeight: [null],
            CollapsedHeight: [null],
            ContainersPerLayer: [null],
            BoxDesign: [null],
            ColorCode: [null],
            TeslaEquipmentCode: [null],
            BurstStrength: [null],
            FluteSize: [null],
            ReturnRatio: [null],
            IsTeslaCreated: false,
            SupplierCode: [null],
            PreferredSecondaryTemplateId: [0],
        });
        this.supplierInfoForm = this.fb.group({
            SupplierCode: [null]
        });
        this.searchSupplierURL = this.appSettings.Packaging2APIUrl + '/externaldata/supplier/all';
    }

    ngOnInit() {
        this.route.paramMap.subscribe(params => {
            this.packageLevelTemplateId = params.get('id');
            if (this.packageLevelTemplateId) {
                this.isUpdateMode = true;
                this.getPackageLevelTemplate(this.packageLevelTemplateId);
            }
            this.getPackageLevelTemplateFiles(this.packageLevelTemplateId);
            this.getPackageLevelTemplateSupCodes(this.packageLevelTemplateId);
        });

        if(this.IsSupplier)
        {
            this.PackageLevelTemplateForm.controls['SupplierCode'].setValue(this.localstorageService.retrieve(this.locStorage.CurrentSupplierCode));
        }
        else
        {
            this.PackageLevelTemplateForm.controls['IsTeslaCreated'].setValue(true);
        }
        this.proposalService.partInfoList.subscribe(parts => {
            this.partNumbers = Array.prototype.map.call(
                parts,
                s => s.PartNumber
            );
        });

    }
    canDeactivate(): boolean {
        return (!this.PackageLevelTemplateForm.dirty || this.SubmitClicked);
      }

    getPackageLevelTemplate(packageLevelTemplateId: string) {
        this.dataService.getPackageLevelTemplate(packageLevelTemplateId).subscribe((response: any) => {
            if (response && response.Data != null) {
                this.packageLevelTemplateDTO = new PackageLevelTemplate();
                this.packageLevelTemplateDTO = cloneDeep(response.Data);
                this.PackageLevelTemplateForm.patchValue(response.Data);
                this.PackageLevelTemplateForm.controls['Id'].setValue(this.packageLevelTemplateId);
                this.updatePackageTemplateUOM(this.packageLevelTemplateDTO.UOMSystemId);
                // if(this.packageLevelTemplateDTO.PackageLevelId == 1)
                // {
                //     this.getSecondaryLevelTemplateCodes();
                // }
                // update measurements only if not default
            }
        });
    }
    updatePackageTemplateUOM(packageUomId: number)
    {
        this.globalUOM = Helper.getUoMObject(packageUomId);
        // this.updateMeasurementsOnLoad();

    }

    onFilterChange() {}

    getDimValue(dim ,uom: UnitOfMeasurement, isWeight = false){
        return Helper.calculateDim(dim, uom, isWeight);
    }

    UserUOMPref(event){
        this.globalUOM = Helper.getUoMObject(event);
        this.updateMeansurements();
    }

    updateMeansurements()
    {
        Helper.updateUOMs(this.PackageLevelTemplateForm, 'ODLength', false, this.globalUOM);
        Helper.updateUOMs(this.PackageLevelTemplateForm, 'ODWidth', false, this.globalUOM);
        Helper.updateUOMs(this.PackageLevelTemplateForm, 'ODHeight', false, this.globalUOM);
        Helper.updateUOMs(this.PackageLevelTemplateForm, 'CollapsedHeight', false, this.globalUOM);
        Helper.updateUOMs(this.PackageLevelTemplateForm, 'IDLength', false, this.globalUOM);
        Helper.updateUOMs(this.PackageLevelTemplateForm, 'IDWidth', false, this.globalUOM);
        Helper.updateUOMs(this.PackageLevelTemplateForm, 'IDHeight', false, this.globalUOM);
        Helper.updateUOMs(this.PackageLevelTemplateForm, 'TareWeight', true, this.globalUOM);
        Helper.updateUOMs(this.PackageLevelTemplateForm, 'MaxWeight', true, this.globalUOM);
    }

  closeWindow()
  {
      window.close();
  }

    /*
      //tms-28072 show attachments in view packagetemplate page
      //tms-29700 set flags to true when uploads/supcode for any plt exists. Show it on view proposal screen when flags are true
    */
    getPackageLevelTemplateFiles(packageLevelTemplateId: string) {
        this.dataService.getpackageLevelTemplateFiles(packageLevelTemplateId).subscribe((response: any) => {
            if (response && response.Data != null) {
                this.packageLevelTemplateFiles = response.Data;
                if (this.packageLevelTemplateFiles.length > 0) {
                    this.isPltUploadExists = true;
                }
            }
        });
    }

    downloadAttachments(PackageTemplateFileId: number) {
        this.dataService.getAttachmentFile(PackageTemplateFileId.toString()).subscribe((response: any) => {
            Helper.downloadAttachments(response['Data']['Base64String'], response['Data']['FileName'], "application/octet-stream;base64");
        });
    }

    getPackageLevelTemplateSupCodes(packageLevelTemplateId: string) {
        this.dataService.getpackageLevelTemplateSupCode(packageLevelTemplateId).subscribe((response: any) => {
            if (response && response.Data != null) {
                this.packageLevelTemplateSupCodes = response.Data;
                if (this.packageLevelTemplateSupCodes.length > 0) {
                    this.isPltSupCodeExists = true;
                }
            }
        });
    }

    refreshToolTipText(code: string) {
        this.supplierAssginmentMessage = Constants[code];
    }
    onEmptySupplierCode(eventObj: any): void {
        this.supplierInfoForm.controls['SupplierCode'].patchValue(null);
        this.SupplierAutoComplete.list = [];
    }

    getSupplierCode() {
        return this.supplierInfoForm.controls['SupplierCode'].value;
    }

    showSupplierAssignmentsSection() {
        if ((this.IsSupplier || this.IsLoggedInAsSupplier) || (!this.PackageLevelTemplateForm.get('IsTeslaCreated').value)) {
            return false;
        }
        return true;
    }

    addSupplierCodeList() {
        //TMS-29696 Before adding new Supplier code, update existing Supplier code list by calling API and then proceed
        this.dataService.getpackageLevelTemplateSupCode(this.packageLevelTemplateId).subscribe((response: any) => {
            if (response && response.Data != null) {
                this.packageLevelTemplateSupCodes = response.Data;

                this.addClicked = true;
                const supplierCode = this.getSupplierCode();

                // Check Existing supplier code list and Newly added Supplier code list
                if (this.supplierCodesList.includes(supplierCode) || this.packageLevelTemplateSupCodes.map(a => a.SupplierCode).includes(parseInt(supplierCode))) {
                    this.toastService.error(
                        'Supplier code already associated'
                    );
                }
                else {
                    this.supplierCodesList.push(supplierCode);
                }
            }
        });
    }

    removeSupplierCodeList(supplierCode: string) {
        if (this.supplierCodesList.includes(supplierCode)) {
            const indexValue = this.supplierCodesList.indexOf(supplierCode);
            this.supplierCodesList.splice(indexValue, 1);
        }
    }

    saveSupplierCode() {
        this.assignSupplierCodetoPLT(this.supplierCodesList, this.packageLevelTemplateId);
    }

    assignSupplierCodetoPLT(supplierCode: string[], id: any) {
        if (supplierCode != null && supplierCode.length != 0) {
            this.addPackageLevelTemplateSupplierDTO.supplierCodesList = supplierCode;
            this.addPackageLevelTemplateSupplierDTO.packageLevelTemplateId = id;
            this.dataService.assignPackageTemplateToSuppliers(this.addPackageLevelTemplateSupplierDTO)
                .subscribe(data => {
                    window.location.reload();
                });
        }
    }

    //tms-29701 Delete supcodes for which no proposals are found having plt attached.
    DeleteSupCodes(id: number, packageTemplateId: number, supplierCode: number) {
        if (Helper.confirmPLTSupCodeDeleteAction()) {
            this.dataService.checkProposalExistsforPLT(packageTemplateId, supplierCode).subscribe((response: any) => {
                if (response) {
                    this.toastService.error(
                        'Proposal Exists with Package Level Template and Supplier.'
                    );
                }
                else {
                    this.dataService.deletePackageTemplateSupCode(id).subscribe((response: any) => {
                        if (response != null && response.Success) {
                            this.toastService.success('Supplier code deleted successfully', true);
                            this.getPackageLevelTemplateSupCodes(packageTemplateId.toString());
                        } else {
                            this.toastService.error(
                                'Could not delete the supplier code'
                            );
                        }
                    });
                }
            });
        }
        else {
            this.toastService.info(
                'Request Cancelled'
            );
        }
    }

    //tms-28072 Maintain array to add/remove files
    onFileAdd(files) {
        if (!files.length) {
            this.loadedFiles = [];
        } else {
            var allowedExtensions = /(\.jpg|\.jpeg|\.docx|\.pdf|\.xlsx)$/i;
            var isValidExtension = true;
            files.forEach(element => {
                var filename = element.name;
                if (!allowedExtensions.exec(filename)) {
                    isValidExtension = false;
                }
                else {
                    this.loadedFiles = [...this.loadedFiles, ...element];
                }
            });

            if (!isValidExtension) {
                this.toastService.error(
                    'Unsupported file extension. Please re-try'
                );
            }
        }
    }


    removeFile(index) {
        this.loadedFiles.splice(index, 1);
    }

    saveAttachments() {
        this.uploadPackageTemplateFile(this.loadedFiles, this.packageLevelTemplateId);
    }

    uploadPackageTemplateFile(files: File[], packageTemplateId: string) {
        if (files.length > 0) {
            this.dataService.uploadPackageTemplateFile(files, packageTemplateId).subscribe(data => {
                window.location.reload();
            });
        }
    }

    DeleteUploadedFile(id: number, packageTemplateId: string) {
        if (Helper.confirmPLTFileDeleteAction()) {
            this.dataService.deletePackageTemplateFile(id).subscribe((response: any) => {
                if (response != null && response.Success) {
                    this.toastService.success('File deleted successfully', true);
                    this.getPackageLevelTemplateFiles(packageTemplateId);
                } else {
                    this.toastService.error(
                        'Could not delete the file'
                    );
                }
            });
        }
    }
}
